import {ErrorMessage, Field, Form, Formik} from "formik";
import * as Yup from "yup";
import axios from "axios";
import {useState} from "react";

const InterviewScheduler = ({candidate, show, onClose, job, rescheduleMode = false, interview = {}}) => {
  const [statusModal, setStatusModal] = useState({
    show: false,
    success: false,
    message: ''
  });

  const validationSchema = Yup.object({
    interviewDate: Yup.date().required('Date is required').min(new Date(), 'Date cannot be in the past'),
    interviewTime: Yup.string().required('Time is required'),
    location: Yup.string().required('Location is required'),
    meetingLink: Yup.string().url('Must be a valid URL'),
    additionalNotes: Yup.string(),
  });

  const initialValues = !rescheduleMode ? {
    interviewDate: null,
    interviewTime: '',
    location: '',
    meetingLink: '',
    additionalNotes: '',
  } : interview;

  const handleSubmit = async (values, {setSubmitting, setErrors}) => {
    try {
      if(!rescheduleMode){
        const response = await axios.post(`${process.env.REACT_APP_API_URL}interviews/schedule`, {
          ...values,
          candidateId: candidate.userid,
          candidateEmail: candidate.email,
          job: job,
          candidate: candidate
        });
        setSubmitting(false);
        setStatusModal({
          show: true,
          success: true,
          message: 'Interview scheduled successfully!'
        });
      } else {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}interviews/reschedule`, {
          ...values,
          interviewId: interview?.interviewId,
        })
        setSubmitting(false);
        setStatusModal({
          show: true,
          success: true,
          message: 'Interview Re-scheduled successfully!'
        });
      }

    } catch (error) {
      setSubmitting(false);
      setStatusModal({
        show: true,
        success: false,
        message: error.message || 'Failed to schedule interview. Please try again.'
      });
    }
  };

  const handleCloseStatusModal = () => {
    setStatusModal({...statusModal, show: false});
    // If it was a success, close the main modal too
    if (statusModal.success) {
      onClose();
    }
  };

  if (!show) return null;

  return (
    <>
      <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Schedule Interview with {candidate.name}</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
              >
                {({values, setFieldValue, isSubmitting}) => (
                  <Form>
                    <div className="mb-3">
                      <label className="form-label">Date</label>
                      <Field
                        name="interviewDate"
                        type="date"
                        className="form-control"
                      >
                      </Field>
                      <ErrorMessage
                        name="interviewDate"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Time</label>
                      <Field
                        type="time"
                        name="interviewTime"
                        className="form-control"
                      />
                      <ErrorMessage
                        name="interviewTime"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Location</label>
                      <Field
                        type="text"
                        name="location"
                        className="form-control"
                        placeholder="Office location or 'Remote'"
                      />
                      <ErrorMessage
                        name="location"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Meeting Link (if remote)</label>
                      <Field
                        type="text"
                        name="meetingLink"
                        className="form-control"
                        placeholder="Video conference link"
                      />
                      <ErrorMessage
                        name="meetingLink"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Additional Notes</label>
                      <Field
                        as="textarea"
                        name="additionalNotes"
                        className="form-control"
                        placeholder="Any additional information for the candidate..."
                        rows={3}
                      />
                      <ErrorMessage
                        name="additionalNotes"
                        component="div"
                        className="text-danger"
                      />
                    </div>

                    <div className="modal-footer px-0 pb-0">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Scheduling...
                          </>
                        ) : (
                          'Schedule Interview'
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="submit"
                      component="div"
                      className="alert alert-danger"
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>

      {statusModal.show && (
        <div className="modal show d-block" style={{backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1060}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  {statusModal.success ? 'Success!' : 'Error'}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={handleCloseStatusModal}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <div className={`alert ${statusModal.success ? 'alert-success' : 'alert-danger'} mb-0`}>
                  {statusModal.message}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleCloseStatusModal}
                >
                  {statusModal.success ? 'Done' : 'Try Again'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default InterviewScheduler;